import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-btn-play",
  "use": "icon-btn-play-usage",
  "viewBox": "0 0 57 57",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 57 57\" id=\"icon-btn-play\"><g fill-rule=\"evenodd\"><path d=\"M0 0h57v57H0z\" /><path d=\"M23.75 17.813L38 27.5 23.75 38z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol